function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { map, kebabCase, camelCase } from 'lodash';

function reconstructName(prefix, variant, suffix) {
    if (!variant) return null;
    var nameParts = [prefix, variant];
    if (suffix) nameParts.push(suffix);
    return kebabCase(nameParts.join('-'));
}

function getNewValue(propName, changes) {
    if (!changes[propName]) return null;
    var _changes$propName = changes[propName],
        currentValue = _changes$propName.currentValue,
        previousValue = _changes$propName.previousValue;

    return currentValue !== previousValue && currentValue;
}

var DynamicComponent = function DynamicComponent($scope, $element, $attrs, $compile, $injector) {
    var _this = this;

    _classCallCheck(this, DynamicComponent);

    var checkAttrs = function checkAttrs() {
        if ($attrs.name && ($attrs.prefix || $attrs.variant)) {
            throw new Error('In DynamicComponent you can not use name and prefix+variant simultaneously');
        }
        if (!$attrs.name && !($attrs.variant && $attrs.prefix)) {
            throw new Error('DynamicComponent expect either name or prefix+variant with optional suffix');
        }
    };

    var componentType = $attrs.name ? 'name' : 'variant';

    var replaceComponent = function replaceComponent(name) {
        if (name) {
            var argString = map(_this.props, function (v, k) {
                return kebabCase(k) + '="' + v + '"';
            }).join(' ');
            var compHtml = '<' + kebabCase(name) + ' ' + argString + '></' + name + '>';
            var component = $compile(compHtml)($scope.$parent)[0];
            $element.replaceWith(component);
        }
    };

    var getName = function getName(name) {
        return name || _this.defaultName;
    };

    var getNameFromVariant = function getNameFromVariant(variant) {
        var _variant = variant || _this.defaultVariant;
        if (!_variant) return null;
        var name = reconstructName(_this.prefix, _variant, _this.suffix);

        if ($injector.has(camelCase([name, 'directive'].join('-')))) {
            return name;
        }
        return reconstructName(_this.prefix, _this.defaultVariant, _this.suffix);
    };

    this.$onInit = function () {
        checkAttrs();
        if (componentType === 'name') {
            return replaceComponent(getName(_this.name));
        }
        if (componentType === 'variant') {
            return replaceComponent(getNameFromVariant(_this.variant));
        }
    };

    this.$onChanges = function (changes) {
        if (componentType === 'name' && changes.name) {
            var newName = getNewValue('name', changes);
            return replaceComponent(getName(newName), _this.props);
        }
        if (componentType === 'variant' && changes.variant) {
            var newVariant = getNewValue('variant', changes);
            replaceComponent(getNameFromVariant(newVariant), _this.props);
        }
        if (changes.props) {
            var name = componentType === 'name' ? getName(_this.name) : getNameFromVariant(_this.variant);
            var newProps = getNewValue('props', changes);
            if (newProps) replaceComponent(name, newProps);
        }
    };
};

DynamicComponent.$inject = ['$scope', '$element', '$attrs', '$compile', '$injector'];

export default DynamicComponent;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/DynamicComponent/DynamicComponentCtrl.js
// module id = 1620
// module chunks = 0